import React, { useState } from "react";

function SearchUser({ onSearch, onClear, showClear, loading }) {
  const [query, setQuery] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setQuery(e.target.value);
    if (error) {
      setError("");
    }
  };

  const handleClear = (e) => {
    e.preventDefault();
    onClear();
    setQuery("");
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = query.trim();

    if (!trimmed) {
      setError("Please enter a GitHub username to search.");
      return;
    }

    setError("");
    onSearch(trimmed);
  };

  return (
    <form className="search-panel" onSubmit={handleSubmit} noValidate>
      <label className="sr-only" htmlFor="github-search">
        Search GitHub users
      </label>
      <div className="search-input-wrap">
        <span className="search-icon">⌕</span>
        <input
          id="github-search"
          type="text"
          placeholder="Search GitHub user..."
          value={query}
          onChange={handleChange}
        />
      </div>
      <div className="search-actions">
        <button className="primary-btn" type="submit" disabled={loading}>
          {loading ? "Searching..." : "Search"}
        </button>
        {showClear && (
          <button className="secondary-btn" type="button" onClick={handleClear}>
            Clear
          </button>
        )}
      </div>
      {error && <p className="field-error">{error}</p>}
    </form>
  );
}

export default SearchUser;
